import React from 'react'
import Header from '../components/kisik/Header'
import Body from '../components/kisik/Body'
import { Helmet } from 'react-helmet'
import { graphql } from 'gatsby'
import Partners from '../components/kisik/Partners'
import StreetMap from '../components/kisik/StreetMap'
import NewReference from '../components/kisik/NewReference'
import NepovratnaSredstva from '../components/kisik/NepovratnaSredstva'

export default function Kisik() {
    return (
        <main>
            <Helmet></Helmet>
            <Header />
            <Body />
            <NewReference />
            <Partners />
            <NepovratnaSredstva />
            <StreetMap />
        </main>
    )
}
export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: {ns: {in: ["common"]}, language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`